{
  "fr": {
    "company": {
      "actions": {
        "changeCompany": "Changer d'organisation",
        "searchCompany": "Rechercher une organisation"
      },
      "attributes": {
        "address": "Adresse",
        "email_address": "Email",
        "iban": "IBAN",
        "language": "Langue",
        "name": "Nom d'organisation",
        "phone": "Téléphone",
        "subdomain": "Subdomain",
        "vat": "TVA"
      },
      "labels": {
        "company": "Organisation",
        "contact": "Contact",
        "contacts": "Contacts",
        "language": "C'est la langue par défaut de l'organisation pour votre page de connexion, vos clients et les membres de votre équipe.",
        "or": "OU"
      },
      "validation": {
        "contactAlreadyExist": "Le contact existe déjà. Veuillez sélectionner dans le menu déroulant.",
        "mustBeEmailAddress": "Adresse e-mail valide requise",
        "needName": "Le nom est requis"
      }
    }
  }
}
